import { api } from '../../../general/apiScenarios';
import { ListenerApiLight, _select, lm } from '../../listenerMiddleware';
import { Page } from '../../models/page';
import { nodeIDChanged } from '../app/actions';
import { getPage, getShareID } from '../app/selectors';
import * as breadcrumbsActions from './actions';

export function breadcrumbsListeners() {
  watchNodeIdChanged();
}

export async function loadBreadcrumbs(lapi: ListenerApiLight, nodeID: number | null | 'trash') {
  if (nodeID === 'trash') {
    return;
  }
  lapi.dispatch(breadcrumbsActions.loadBreadcrumbsStarted());

  const getPageResult: ReturnType<typeof getPage> = _select(lapi, getPage);
  const getShareIdResult: ReturnType<typeof getShareID> = _select(lapi, getShareID);
  const result = await apiRequestBreadcrumbs(nodeID ?? undefined, getPageResult, getShareIdResult);
  if (lapi.signal.aborted) return;
  if (result.success) {
    lapi.dispatch(breadcrumbsActions.loadBreadcrumbsSuccess({ nodes: result.data.response.nodes }));
  } else {
    lapi.dispatch(breadcrumbsActions.loadBreadcrumbsError({ error: result.reason }));
  }
}

function watchNodeIdChanged() {
  lm.takeLatest(nodeIDChanged, async function (action, lapi) {
    await loadBreadcrumbs(lapi, action.payload.nodeID);
  });
}

export async function apiRequestBreadcrumbs(
  nodeID: number | undefined,
  getPageResult: ReturnType<typeof getPage>,
  getShareIDResult: ReturnType<typeof getShareID>,
) {
  if (getPageResult === Page.SHARED_FOLDER) {
    if (getShareIDResult === null) throw new Error('shareId can not be null here');
    const result = await api.fs.listShareParents(getShareIDResult, nodeID);
    return result;
  } else {
    const result = await api.fs.listParents(nodeID);
    return result;
  }
}
